import { get } from 'lodash';
import { routingConfigStore } from '../config/routingConfigStore';
import { useModuleName } from './useModuleName';

export const useModuleConfigAttribute = ({ attribute, defaultValue = false }) => {
    const moduleName = useModuleName();
    const routingConfig = routingConfigStore.getValue();

    // not using path as array to support nested attributes
    return get(routingConfig, `routingMap.${moduleName}.${attribute}`, defaultValue);
};
